import React, { useState, useEffect } from "react";
import ReactEcharts from "echarts-for-react";
import { op1 } from "./option";

const Component = (props: any) => {
  const { source,unit,title } = props;
  return (
    <div>
      <ReactEcharts
        option={op1(title,source,unit)}
        notMerge={true}
        lazyUpdate={true}
        style={{ height: "540px", width: "100%" }}
      />
    </div>
  );
};

export default Component;
